// Floating action button that opens the parlay builder sheet.
// Shows the current leg count badge; only renders once legs exist OR after
// the user has engaged with "+ Parlay" at least once.

import React from "react";
import { Layers } from "lucide-react";
import { useParlay, MIN_LEGS } from "@/lib/parlay";
import { useAuth } from "@/lib/auth";
import { canUse, usePaywall } from "@/lib/access";

const ACCENT = "#067647";

export default function ParlayFab() {
  const { legs, setOpen } = useParlay();
  const { user } = useAuth();
  const { openPaywall } = usePaywall();
  if (legs.length === 0 || user?.locked_out) return null;
  const allowed = canUse(user, "betting");
  const canPrice = legs.length >= MIN_LEGS;
  return (
    <button
      type="button"
      onClick={() => (allowed ? setOpen(true) : openPaywall("betting"))}
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2.5 px-5 py-3 font-display font-extrabold uppercase tracking-[0.15em] text-sm border-2 shadow-lg active:translate-y-px focus-ring"
      style={{ background: canPrice ? ACCENT : "#111", color: "#fff", borderColor: canPrice ? ACCENT : "#111" }}
      data-testid="parlay-fab"
      aria-label="Open parlay builder"
    >
      <Layers size={16} strokeWidth={2.6} />
      Parlay slip
      <span
        className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full text-xs font-extrabold"
        style={{ background: "#fff", color: canPrice ? ACCENT : "#111" }}
        data-testid="parlay-fab-count"
      >
        {legs.length}
      </span>
    </button>
  );
}
